<template>
  <div class="q-mt-md">
    <div
      class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold q-mb-md items-center"
    >
      <div class="col-md col-xs-6 col-sm-6">
        <div>Unidade</div>
        <UnidadeSelect
          class="input-new-design"
          v-model="filtros.unidade"
          :todas="temPermissaoTodasUnidades"
        />
      </div>
      <div class="col-md col-xs-5 col-sm-5">
        <div>Código</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          debounce="400"
          v-model="filtros.code"
        />
      </div>
      <div class="col-md col-xs-5 col-sm-5">
        <div>Com Divergência</div>
        <q-select
          class="input-new-design"
          dense
          outlined
          :options="optionsComDiferenca"
          debounce="400"
          v-model="filtros.comDiferenca"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          icon="history"
          flat
          color="positive"
          round
          @click="forcarCalculoEstoque()"
        />
      </div>
    </div>

    <!-- Modal: usuário sem permissão e sem unidade selecionada -->
    <dialog-info-design
      mensagem="Selecione uma Unidade para continuar"
      sub-mensagem="Por favor, selecione uma Unidade no filtro antes de prosseguir."
      :exibir="modalSelecioneUnidade"
      :esconder-confirme="true"
      :show-cancelar="true"
      @resultado="modalSelecioneUnidade = false"
    />

    <div
      v-if="!temPermissaoTodasUnidades && !filtros.unidade?.id"
      class="row col-12 q-mt-md"
    ></div>

    <template v-else>
      <q-table
        :columns="columns"
        :rows="rows"
        class="tabela-tamanho-fixo"
        table-header-style="background-color: #d9effc"
        dense
        flat
        :loading="loading"
        color="primary"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[15, 25, 50, 100]"
        @request="paginarTabela"
        v-model:pagination="pagination"
      >
        <template v-slot:header="props">
          <q-tr style="background-color: #d9effc" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:top-right>
          <q-btn
            label="Exportar"
            no-caps
            color="brand-1"
            icon="sym_o_download"
            @click="filtros.download = 'xls'"
          />
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.vendor_nome }}
            </q-td>
            <q-td>
              {{ props.row.produto_codigo }}
            </q-td>
            <q-td>
              {{ props.row.produto_descricao }}
            </q-td>
            <q-td>
              {{ props.row.categoria_codigo }}
            </q-td>
            <q-td>
              {{ props.row.categoria_descricao }}
            </q-td>
            <q-td>
              {{ props.row.grupo_nome }}
            </q-td>
            <q-td>
              {{ props.row.estoque_total }}
            </q-td>
            <q-td>
              {{ props.row.entradas }}
            </q-td>
            <q-td>
              {{ props.row.saidas }}
            </q-td>
            <q-td>
              {{ props.row.balanco }}
            </q-td>
            <q-td>
              {{ props.row.diferenca }}
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";

import UnidadeSelect from "../../../components/unidade/UnidadeSelect.vue";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";

const columns = [
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
    field: "vendor_nome",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "produto_codigo",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: "produto_descricao",
  },
  {
    name: "codigoCategoria",
    label: "Código Categoria",
    align: "left",
    field: "categoria_codigo",
  },
  {
    name: "descricaoCategoria",
    label: "Descrição Categoria",
    align: "left",
    field: "categoria_descricao",
  },
  {
    name: "grupoProduto",
    label: "Grupo de Produto",
    align: "left",
    field: "grupo_nome",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    field: "estoque_total",
  },
  {
    name: "entradas",
    label: "Entradas",
    align: "left",
    field: "entradas",
  },
  {
    name: "saidas",
    label: "Saídas",
    align: "left",
    field: "entradas",
  },
  {
    name: "balanco",
    label: "Balanço",
    align: "left",
    field: "entradas",
  },
  {
    name: "diferenca",
    label: "Diferença",
    align: "left",
    field: "diferenca",
  },
];

const store = useStore();
const quasar = useQuasar();

// Computed que verifica se o usuário tem a permissão "visualizar_todas_unidades"
const temPermissaoTodasUnidades = computed(() =>
  usuarioTemPermissao(store, "visualizar_todas_unidades")
);

const filtros = ref({
  comDiferenca: "",
  unidade: {
    nome: "Todas",
    id: "",
  },
  code: "",
  download: undefined,
});

const optionsComDiferenca = ref([
  {
    label: "Sim",
    value: "sim",
  },
  {
    label: "Não",
    value: "nao",
  },
]);
const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 15,
});
const rows = ref([]);
const loading = ref(false);
const modalSelecioneUnidade = ref(false);

const listarVerificacaoEstoque = async (page = 1, perPage = 15) => {
  // Bloqueia a busca se o usuário não tem permissão e não selecionou uma unidade
  if (!temPermissaoTodasUnidades.value && !filtros.value.unidade?.id) {
    modalSelecioneUnidade.value = true;
    return;
  }

  loading.value = true;
  try {
    const response = await store.dispatch("ind/listarVerificacaoEstoque", {
      com_diferenca: filtros.value.comDiferenca?.value,
      vendor_id: filtros.value.unidade?.id,
      code: filtros.value.code,
      per_page: perPage,
      page: page,
      download: filtros.value.download,
    });

    if (filtros.value.download == "xls") {
      filtros.value.download = undefined;
      quasar.notify({
        message:
          "O relatório foi exportado, você receberá o link para download em breve em seu email.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      loading.value = false;
      return;
    }

    rows.value = response.data.result.data;

    pagination.value.page = response.data.result.current_page;
    pagination.value.rowsPerPage = response.data.result.per_page;
    pagination.value.rowsNumber = response.data.result.total;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const forcarCalculoEstoque = async () => {
  try {
    await store.dispatch("ind/forcarCalculoEstoque");
    quasar.notify({
      message: "O relatório será recalculado.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    listarVerificacaoEstoque();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao calcular relatório.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const paginarTabela = (props) => {
  listarVerificacaoEstoque(props.pagination.page, props.pagination.rowsPerPage);
};

watch(
  [
    () => filtros.value.unidade,
    () => filtros.value.code,
    () => filtros.value.comDiferenca,
  ],
  () => {
    listarVerificacaoEstoque();
  }
);

watch(
  () => filtros.value.download,
  () => {
    if (filtros.value.download == "xls") {
      listarVerificacaoEstoque();
    }
  }
);

onMounted(() => {
  if (!temPermissaoTodasUnidades.value) {
    filtros.value.unidade = { nome: "", id: "" };
  }
  listarVerificacaoEstoque();
});
</script>

<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field--outlined .q-field__control:focus {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
